import React from 'react'

import './css/Admin.css'

export default props => {
  const days = ['Day 1', 'Day 2', 'Day 3']

  const uid = props.uid ? props.uid.substr(0, 6) : '';

  const renderDayButtons = () => {
    return days.map((day, index) => {
      const className = index === props.currentDay ? 'is-success' : ''
      return (
        <a key={day}
          className={`button is-large ${className}`}
          onClick={() => props.changeDay(index)}
        >{day}</a>
      )
    })
  }

  const renderSaveDeleteButtons = () => {
    if(props.scores.length){
      return (
        <div>
          <a className="button is-primary" onClick={() => props.saveCSV()}>Save Scores to CSV</a>
          <a className="button is-danger" onClick={() => props.clearLocal()}>Remove All Local Scores</a>
        </div>
      )
    }

  }

  const uidClick = (e) => {
    e.target.select()
  }

  return (
    <div className="Admin">
      <p className="control">
        <label>UID</label>
        <input onClick={e => uidClick(e)} readOnly className="input is-medium" type="text" value={uid} />
      </p>
      <div className="AdminDays">
        { renderDayButtons() }
      </div>
      <div className="AdminDays">
        <a className="button is-large" onClick={() => props.changeScreen('Welcome')}>Return Home</a>
        <a className="button is-large is-primary" onClick={() => props.changeScreen('Scores')}>Show Scores</a>
        <a className="button is-large is-primary" onClick={() => props.changeScreen('Game')}>Show Game</a>
      </div>
      { renderSaveDeleteButtons() }
      <div className="thrive">Created by <a target="_blank" href="https://thriveweb.com.au">Thrive</a></div>
    </div>
  )
}



/** WEBPACK FOOTER **
 ** ./src/Admin.js
 **/